import { ICodeInputConfig } from './codeInput.config';
import { translate } from 'angular';
export default function anFn_17927(codeInputConfig: ICodeInputConfig, $translate: translate.ITranslateService) {
  codeInputConfig.defaultSendText = $translate.instant('Js.CodeInput.DefaultSendText');
  codeInputConfig.defaultResendText = $translate.instant('Js.CodeInput.DefaultResendText');
}
anFn_17927.$inject = ["codeInputConfig", "$translate"];
;